/**
 * Sets the current CSO id on the csoManager
 * @param {string} id - the id of the CSO
 */
export function setId(id) {
  this.id = id;
}
